import { useEffect, useState, useRef } from "@wordpress/element";

function FaqsItem({ faq, isOpen }) {
  const [isActive, setIsActive] = useState(isOpen);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef(null);

  const toggleItem = (faqId) => {
    setIsActive(!isActive);
  };

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(isOpen ? contentRef.current.scrollHeight : 0);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isActive && contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    } else {
      setContentHeight(0);
    }
  }, [isActive, faq]);

  return (
    <div id={`faq-item-${faq.id}`} className="content-faqs__item pb-1">
      <header className="content-faqs__item-header">
        <button
          onClick={() => toggleItem(faq.id)}
          aria-expanded={isActive}
          className="content-faqs__item-toggle-button"
          tabIndex={0}
        >
          <h3 className="wp-block-heading has-text-black-500-color fw-700">{faq.title}</h3>
          <span className={`content-faqs__item-toggle ${isActive ? 'is-open' : 'is-closed'}`}></span>
        </button>
      </header>

      <div
        className={`${isActive ? 'active' : ''} content-faqs__item-content`}
        style={{ height: `${contentHeight}px`, overflow: 'hidden', transition: 'height 0.3s ease' }}
        aria-hidden={!isActive}
      >
        <div ref={contentRef} className="content-faqs__item-content-inner pt-1 pb-1 has-text-gray-500-color">
          <div dangerouslySetInnerHTML={{ __html: faq.content }}></div>
        </div>
      </div>
    </div>
  );
}

export default FaqsItem;
